<template>
  <b-container>
    <b-navbar toggleable="lg" type="dark" variant="dark">
      <b-navbar-brand v-on:click="reload" mx-auto class="logo">
        <img
          v-bind:src="
            $i18n.locale === 'fr'
              ? 'Images/cogir-rev-fr-110x110.png'
              : 'Images/cogir-rev-en-110x110.png'
          "
          class="d-inline-block align-top"
          alt="logo cogir"
        />
      </b-navbar-brand>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav v-if="user" class="ml-auto">
          <b-nav-item
            v-on:click="goTo('Dashboard')"
            >{{ $t("title.dashboard") }}</b-nav-item
          >
          <b-nav-item-dropdown right v-if="user">
            <template v-slot:button-content>
              <em>{{ user.fname.concat(" " + user.lname) }}</em>
            </template>
            <b-dropdown-item v-on:click="logOut()">{{
              $t("action.logout")
            }}</b-dropdown-item>
            <b-dropdown-item v-on:click="getLang('en')">{{
              $t("label.english")
            }}</b-dropdown-item>
            <b-dropdown-item v-on:click="getLang('fr')">{{
              $t("label.french")
            }}</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </b-container>
</template>

<script>
export default {
  data: () => ({}),
  mounted() {},
  computed: {
    user: function () {
      return this.$store.getters.getUser;
    },
    getApplicationReady: function () {
      return this.$store.getters.getApplicationReady;
    },
  },
  methods: {
    getLang: function (val) {
      this.$i18n.locale = val;
      this.$emit("changeLg", val);
    },
    goTo: function (val) {
      this.$emit("changePage", val);
    },
    logOut: function () {
      let myMSALObj = this.$store.getters.getmsalObj;
      myMSALObj ? myMSALObj.logout() : this.$emit("changePage", "Login");
    },
    reload: function () {
      window.location.reload(true);
    },
  },
  components: {},
};
</script>
